import { StyledPopoverCard, StyledPopoverCardWithOutPortal } from "./Popover.styles";
import { forwardRef, useEffect, useRef } from "react";

const PopoverCard = forwardRef((props, ref) => {
  const { children, ...rest } = props;
  return (
    <StyledPopoverCard ref={ref} {...rest}>
      {children}
    </StyledPopoverCard>
  );
});

const PopoverCardWithOutPortal = forwardRef(({ onClose, children, ...rest }, forwardedRef) => {
  // Internal ref to the dropdown element
  const innerRef = useRef(null);

  // Merge forwardedRef and innerRef
  const setRefs = node => {
    innerRef.current = node;
    if (typeof forwardedRef === "function") forwardedRef(node);
    else if (forwardedRef) forwardedRef.current = node;
  };

  // Listen for clicks outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = event => {
      if (innerRef.current && !innerRef.current.contains(event.target)) {
        onClose?.();
      }
    };
    document.addEventListener("pointerdown", handleClickOutside, true);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside, true);
    };
  }, [onClose]);

  return (
    <StyledPopoverCardWithOutPortal ref={setRefs} {...rest}>
      {children}
    </StyledPopoverCardWithOutPortal>
  );
});

export { PopoverCard, PopoverCardWithOutPortal };
